import { render } from "./TrafficLightLegend.vue?vue&type=template&id=827d8a90&scoped=true"
import script from "./TrafficLightLegend.vue?vue&type=script&lang=js"
export * from "./TrafficLightLegend.vue?vue&type=script&lang=js"

import "./TrafficLightLegend.vue?vue&type=style&index=0&id=827d8a90&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827d8a90"]])

export default __exports__